/*
  Fit Guide modal: opens from the link beside the size chips, shows the size
  chart, and recommends a size from height + weight.

  Rules come from the section settings as one line per size:
    SIZE,minHeightInches,maxHeightInches,minPounds,maxPounds
  e.g.  M,66,70,150,185

  A match needs both height and weight in range. If only one matches we say so
  rather than inventing a size — a wrong recommendation costs a return.
*/
(function () {
  /*
    Rules encode the store's size chart as a height x weight matrix, matching
    the Staples chart image:

      WEIGHTS,90,100,110,...          <- weight columns, in pounds
      58,60,XS,XS,S,...               <- minHeightIn,maxHeightIn,size per column

    A matrix beats min/max ranges here because the chart genuinely varies by
    both axes: 5'7" is an S at 90lb and an L at 140lb.
  */
  function parseRules(raw) {
    var weights = [];
    var rows = [];
    (raw || '').split('\n').forEach(function (line) {
      var p = line.split(',').map(function (x) { return x.trim(); });
      if (!p[0]) return;
      if (/^weights$/i.test(p[0])) {
        weights = p.slice(1).map(Number).filter(function (n) { return !isNaN(n); });
        return;
      }
      var minH = parseFloat(p[0]);
      var maxH = parseFloat(p[1]);
      if (isNaN(minH) || isNaN(maxH)) return;
      rows.push({ minH: minH, maxH: maxH, sizes: p.slice(2) });
    });
    return { weights: weights, rows: rows };
  }

  function nearestIndex(weights, pounds) {
    var best = 0;
    var bestDiff = Infinity;
    weights.forEach(function (w, i) {
      var diff = Math.abs(w - pounds);
      if (diff < bestDiff) {
        bestDiff = diff;
        best = i;
      }
    });
    return best;
  }

  function recommend(chart, inches, pounds) {
    if (!chart.rows.length || !chart.weights.length) return null;

    var row = null;
    for (var i = 0; i < chart.rows.length; i++) {
      if (inches >= chart.rows[i].minH && inches <= chart.rows[i].maxH) {
        row = chart.rows[i];
        break;
      }
    }

    // Outside the charted heights: clamp to the nearest end rather than giving up
    var clamped = false;
    if (!row) {
      clamped = true;
      row = inches < chart.rows[0].minH ? chart.rows[0] : chart.rows[chart.rows.length - 1];
    }

    var idx = nearestIndex(chart.weights, pounds);
    if (pounds < chart.weights[0] || pounds > chart.weights[chart.weights.length - 1]) {
      clamped = true;
    }

    var size = row.sizes[idx];
    if (!size) return null;
    return { size: size, exact: !clamped };
  }

  function init() {
    var openBtn = document.querySelector('[data-fit-guide-open]');
    var modal = document.querySelector('[data-fit-guide-modal]');
    if (!openBtn || !modal) return;

    // Hot reload re-runs this file without unwinding the previous run, which
    // left duplicate listeners and a stuck scroll lock. Bind once, and clear
    // any lock a previous run left behind.
    if (modal.dataset.fitGuideReady) return;
    modal.dataset.fitGuideReady = '1';

    // Clear any lock left by a previous run before binding (hot reload, or an
    // earlier build that could strand the page unscrollable).
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';

    // Reparent to <body>: the modal is authored inside the sticky product info
    // column, whose containing block clips `position: fixed`, so the backdrop
    // only dimmed part of the viewport.
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    var dialog = modal.querySelector('.fm-fit-guide__dialog');
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      modal.dataset.open = '1';
      // Lock the page behind the modal, as the reference does. Paired with the
      // unconditional release in close() and the clear on init above.
      document.documentElement.style.overflow = 'hidden';
      dialog.focus();
    }

    function close() {
      modal.hidden = true;
      modal.dataset.open = '';
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }

    openBtn.addEventListener('click', open);

    modal.querySelectorAll('[data-fit-guide-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    // Click the backdrop, not the dialog, to dismiss
    modal.addEventListener('click', function (e) {
      if (e.target === modal) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });

    var form = modal.querySelector('[data-fit-guide-form]');
    if (!form) return;

    var chart = parseRules(form.dataset.rules);
    var result = form.querySelector('[data-fit-guide-result]');

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var feet = parseFloat(form.elements.feet.value) || 0;
      var inches = feet * 12 + (parseFloat(form.elements.inches.value) || 0);
      var pounds = parseFloat(form.elements.weight.value) || 0;

      if (!inches || !pounds) {
        result.textContent = 'Enter your height and weight to see a suggestion.';
        result.className = 'fm-fit-guide__result';
        return;
      }

      var match = recommend(chart, inches, pounds);
      if (!match) {
        result.textContent =
          "We couldn't match that — check the chart below, or message us and we'll help.";
        result.className = 'fm-fit-guide__result fm-fit-guide__result--none';
        return;
      }

      result.textContent = match.exact
        ? 'We recommend size ' + match.size + '.'
        : 'Size ' + match.size + ' is the closest fit — you are near the edge of our chart.';
      result.className =
        'fm-fit-guide__result fm-fit-guide__result--' + (match.exact ? 'exact' : 'close');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
